// ── Roles ──
export const ROLES = ['agent', 'administrator'];

// ── CRM: Deals ──
export const DEAL_VIEW_ALL = 'deal_view_all';
export const DEAL_VIEW_OWN = 'deal_view_own';
export const DEAL_CREATE = 'deal_create';
export const DEAL_EDIT_ALL = 'deal_edit_all';
export const DEAL_EDIT_OWN = 'deal_edit_own';
export const DEAL_DELETE = 'deal_delete';
export const DEAL_EXPORT = 'deal_export';
export const DEAL_BULK_OPERATIONS = 'deal_bulk_operations';

// ── CRM: Pipelines ──
export const PIPELINE_VIEW = 'pipeline_view';
export const PIPELINE_CREATE = 'pipeline_create';
export const PIPELINE_EDIT = 'pipeline_edit';
export const PIPELINE_DELETE = 'pipeline_delete';

// ── CRM: Forms ──
export const FORM_VIEW = 'form_view';
export const FORM_CREATE = 'form_create';
export const FORM_EDIT = 'form_edit';
export const FORM_DELETE = 'form_delete';
export const FORM_PUBLISH = 'form_publish';

// ── CRM: Tasks ──
export const TASK_VIEW_ALL = 'task_view_all';
export const TASK_VIEW_OWN = 'task_view_own';
export const TASK_CREATE = 'task_create';
export const TASK_EDIT_ALL = 'task_edit_all';
export const TASK_EDIT_OWN = 'task_edit_own';
export const TASK_DELETE = 'task_delete';

// ── CRM: Tickets ──
export const TICKET_VIEW_ALL = 'ticket_view_all';
export const TICKET_VIEW_OWN = 'ticket_view_own';
export const TICKET_CREATE = 'ticket_create';
export const TICKET_EDIT_ALL = 'ticket_edit_all';
export const TICKET_EDIT_OWN = 'ticket_edit_own';
export const TICKET_DELETE = 'ticket_delete';

// ── CRM: Segments ──
export const SEGMENT_VIEW = 'segment_view';
export const SEGMENT_CREATE = 'segment_create';
export const SEGMENT_EDIT = 'segment_edit';
export const SEGMENT_DELETE = 'segment_delete';

// ── CRM: Products ──
export const PRODUCT_VIEW = 'product_view';
export const PRODUCT_CREATE = 'product_create';
export const PRODUCT_EDIT = 'product_edit';
export const PRODUCT_DELETE = 'product_delete';

// ── Reports ──
export const REPORT_CRM_VIEW = 'report_crm_view';
export const REPORT_CONVERSATION_VIEW = 'report_conversation_view';
export const REPORT_AGENT_VIEW = 'report_agent_view';
export const REPORT_EXPORT = 'report_export';

// ── Conversations ──
export const CONVERSATION_MANAGE = 'conversation_manage';
export const CONVERSATION_UNASSIGNED_MANAGE = 'conversation_unassigned_manage';
export const CONVERSATION_PARTICIPATING_MANAGE =
  'conversation_participating_manage';

// ── Contacts ──
export const CONTACT_VIEW = 'contact_view';
export const CONTACT_CREATE = 'contact_create';
export const CONTACT_EDIT = 'contact_edit';
export const CONTACT_DELETE = 'contact_delete';
export const CONTACT_EXPORT = 'contact_export';
export const CONTACT_IMPORT = 'contact_import';

// ── Companies ──
export const COMPANY_VIEW = 'company_view';
export const COMPANY_CREATE = 'company_create';
export const COMPANY_EDIT = 'company_edit';
export const COMPANY_DELETE = 'company_delete';

// ── Settings ──
export const SETTINGS_MANAGE_AGENTS = 'settings_manage_agents';
export const SETTINGS_MANAGE_ROLES = 'settings_manage_roles';
export const SETTINGS_MANAGE_INBOXES = 'settings_manage_inboxes';
export const SETTINGS_MANAGE_ACCOUNT = 'settings_manage_account';
export const SETTINGS_MANAGE_INTEGRATIONS = 'settings_manage_integrations';

// ── Social ──
export const SOCIAL_VIEW = 'social_view';
export const SOCIAL_MANAGE = 'social_manage';
export const SOCIAL_CONFIGURE = 'social_configure';

// ── Macros ──
export const MACRO_MANAGE = 'macro_manage';

// ── Workflows & Automations ──
export const WORKFLOW_VIEW = 'workflow_view';
export const WORKFLOW_MANAGE = 'workflow_manage';

// ── Broadcasts ──
export const BROADCAST_VIEW = 'broadcast_view';
export const BROADCAST_CREATE = 'broadcast_create';
export const BROADCAST_MANAGE = 'broadcast_manage';

// ── Captain / Brain AI ──
export const CAPTAIN_VIEW = 'captain_view';
export const CAPTAIN_MANAGE = 'captain_manage';

// ── Agent Management ──
export const AGENT_MANAGE = 'agent_manage';

// ── CRM Config ──
export const CRM_CONFIG_MANAGE = 'crm_config_manage';

// ── Legacy aliases (backward compat) ──
export const MANAGE_ALL_CONVERSATION_PERMISSIONS = CONVERSATION_MANAGE;
export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  CONVERSATION_UNASSIGNED_MANAGE;
export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  CONVERSATION_PARTICIPATING_MANAGE;
export const CONTACT_PERMISSIONS = CONTACT_EDIT;
export const REPORTS_PERMISSIONS = REPORT_CONVERSATION_VIEW;
export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// ── Conversation permissions array ──
export const CONVERSATION_PERMISSIONS = [
  CONVERSATION_MANAGE,
  CONVERSATION_UNASSIGNED_MANAGE,
  CONVERSATION_PARTICIPATING_MANAGE,
];

// ── Assignee type tab permissions ──
export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};

// ── All available permissions (mirrors backend CustomRole::PERMISSIONS) ──
export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  // Deals
  DEAL_VIEW_ALL,
  DEAL_VIEW_OWN,
  DEAL_CREATE,
  DEAL_EDIT_ALL,
  DEAL_EDIT_OWN,
  DEAL_DELETE,
  DEAL_EXPORT,
  DEAL_BULK_OPERATIONS,
  // Pipelines
  PIPELINE_VIEW,
  PIPELINE_CREATE,
  PIPELINE_EDIT,
  PIPELINE_DELETE,
  // Forms
  FORM_VIEW,
  FORM_CREATE,
  FORM_EDIT,
  FORM_DELETE,
  FORM_PUBLISH,
  // Tasks
  TASK_VIEW_ALL,
  TASK_VIEW_OWN,
  TASK_CREATE,
  TASK_EDIT_ALL,
  TASK_EDIT_OWN,
  TASK_DELETE,
  // Tickets
  TICKET_VIEW_ALL,
  TICKET_VIEW_OWN,
  TICKET_CREATE,
  TICKET_EDIT_ALL,
  TICKET_EDIT_OWN,
  TICKET_DELETE,
  // Segments
  SEGMENT_VIEW,
  SEGMENT_CREATE,
  SEGMENT_EDIT,
  SEGMENT_DELETE,
  // Products
  PRODUCT_VIEW,
  PRODUCT_CREATE,
  PRODUCT_EDIT,
  PRODUCT_DELETE,
  // Reports
  REPORT_CRM_VIEW,
  REPORT_CONVERSATION_VIEW,
  REPORT_AGENT_VIEW,
  REPORT_EXPORT,
  // Conversations
  CONVERSATION_MANAGE,
  CONVERSATION_UNASSIGNED_MANAGE,
  CONVERSATION_PARTICIPATING_MANAGE,
  // Contacts
  CONTACT_VIEW,
  CONTACT_CREATE,
  CONTACT_EDIT,
  CONTACT_DELETE,
  CONTACT_EXPORT,
  CONTACT_IMPORT,
  // Companies
  COMPANY_VIEW,
  COMPANY_CREATE,
  COMPANY_EDIT,
  COMPANY_DELETE,
  // Settings
  SETTINGS_MANAGE_AGENTS,
  SETTINGS_MANAGE_ROLES,
  SETTINGS_MANAGE_INBOXES,
  SETTINGS_MANAGE_ACCOUNT,
  SETTINGS_MANAGE_INTEGRATIONS,
  // Social
  SOCIAL_VIEW,
  SOCIAL_MANAGE,
  SOCIAL_CONFIGURE,
  // Macros
  MACRO_MANAGE,
  // Workflows
  WORKFLOW_VIEW,
  WORKFLOW_MANAGE,
  // Broadcasts
  BROADCAST_VIEW,
  BROADCAST_CREATE,
  BROADCAST_MANAGE,
  // Captain / Brain
  CAPTAIN_VIEW,
  CAPTAIN_MANAGE,
  // Agent Management
  AGENT_MANAGE,
  // CRM Config
  CRM_CONFIG_MANAGE,
];

// ── Permission groups for UI (mirrors backend CustomRole::PERMISSION_GROUPS) ──
export const PERMISSION_GROUPS = {
  deals: {
    label: 'Deals',
    permissions: [
      DEAL_VIEW_ALL,
      DEAL_VIEW_OWN,
      DEAL_CREATE,
      DEAL_EDIT_ALL,
      DEAL_EDIT_OWN,
      DEAL_DELETE,
      DEAL_EXPORT,
      DEAL_BULK_OPERATIONS,
    ],
  },
  pipelines: {
    label: 'Pipelines',
    permissions: [
      PIPELINE_VIEW,
      PIPELINE_CREATE,
      PIPELINE_EDIT,
      PIPELINE_DELETE,
    ],
  },
  forms: {
    label: 'Formulários',
    permissions: [FORM_VIEW, FORM_CREATE, FORM_EDIT, FORM_DELETE, FORM_PUBLISH],
  },
  tasks: {
    label: 'Tarefas',
    permissions: [
      TASK_VIEW_ALL,
      TASK_VIEW_OWN,
      TASK_CREATE,
      TASK_EDIT_ALL,
      TASK_EDIT_OWN,
      TASK_DELETE,
    ],
  },
  tickets: {
    label: 'Tickets',
    permissions: [
      TICKET_VIEW_ALL,
      TICKET_VIEW_OWN,
      TICKET_CREATE,
      TICKET_EDIT_ALL,
      TICKET_EDIT_OWN,
      TICKET_DELETE,
    ],
  },
  segments: {
    label: 'Segmentos',
    permissions: [SEGMENT_VIEW, SEGMENT_CREATE, SEGMENT_EDIT, SEGMENT_DELETE],
  },
  products: {
    label: 'Produtos',
    permissions: [PRODUCT_VIEW, PRODUCT_CREATE, PRODUCT_EDIT, PRODUCT_DELETE],
  },
  reports: {
    label: 'Relatórios',
    permissions: [
      REPORT_CRM_VIEW,
      REPORT_CONVERSATION_VIEW,
      REPORT_AGENT_VIEW,
      REPORT_EXPORT,
    ],
  },
  conversations: {
    label: 'Conversas',
    permissions: [
      CONVERSATION_MANAGE,
      CONVERSATION_UNASSIGNED_MANAGE,
      CONVERSATION_PARTICIPATING_MANAGE,
    ],
  },
  contacts: {
    label: 'Contatos',
    permissions: [
      CONTACT_VIEW,
      CONTACT_CREATE,
      CONTACT_EDIT,
      CONTACT_DELETE,
      CONTACT_EXPORT,
      CONTACT_IMPORT,
    ],
  },
  companies: {
    label: 'Empresas',
    permissions: [COMPANY_VIEW, COMPANY_CREATE, COMPANY_EDIT, COMPANY_DELETE],
  },
  settings: {
    label: 'Configurações',
    permissions: [
      SETTINGS_MANAGE_AGENTS,
      SETTINGS_MANAGE_ROLES,
      SETTINGS_MANAGE_INBOXES,
      SETTINGS_MANAGE_ACCOUNT,
      SETTINGS_MANAGE_INTEGRATIONS,
    ],
  },
  social: {
    label: 'Social',
    permissions: [SOCIAL_VIEW, SOCIAL_MANAGE, SOCIAL_CONFIGURE],
  },
  macros: {
    label: 'Macros',
    permissions: [MACRO_MANAGE],
  },
  workflows: {
    label: 'Workflows',
    permissions: [WORKFLOW_VIEW, WORKFLOW_MANAGE],
  },
  broadcasts: {
    label: 'Disparos',
    permissions: [BROADCAST_VIEW, BROADCAST_CREATE, BROADCAST_MANAGE],
  },
  captain: {
    label: 'Brain / IA',
    permissions: [CAPTAIN_VIEW, CAPTAIN_MANAGE],
  },
  agents: {
    label: 'Agentes',
    permissions: [AGENT_MANAGE],
  },
  crm_config: {
    label: 'CRM Config',
    permissions: [CRM_CONFIG_MANAGE],
  },
};

// ── Permission labels for UI ──
export const PERMISSION_LABELS = {
  deal_view_all: 'Ver todos os deals',
  deal_view_own: 'Ver apenas seus deals',
  deal_create: 'Criar deals',
  deal_edit_all: 'Editar todos os deals',
  deal_edit_own: 'Editar apenas seus deals',
  deal_delete: 'Excluir deals',
  deal_export: 'Exportar deals',
  deal_bulk_operations: 'Operações em massa',
  pipeline_view: 'Ver pipelines',
  pipeline_create: 'Criar pipelines',
  pipeline_edit: 'Editar pipelines',
  pipeline_delete: 'Excluir pipelines',
  form_view: 'Ver formulários',
  form_create: 'Criar formulários',
  form_edit: 'Editar formulários',
  form_delete: 'Excluir formulários',
  form_publish: 'Publicar/arquivar formulários',
  task_view_all: 'Ver todas as tarefas',
  task_view_own: 'Ver apenas suas tarefas',
  task_create: 'Criar tarefas',
  task_edit_all: 'Editar todas as tarefas',
  task_edit_own: 'Editar apenas suas tarefas',
  task_delete: 'Excluir tarefas',
  ticket_view_all: 'Ver todos os tickets',
  ticket_view_own: 'Ver apenas seus tickets',
  ticket_create: 'Criar tickets',
  ticket_edit_all: 'Editar todos os tickets',
  ticket_edit_own: 'Editar apenas seus tickets',
  ticket_delete: 'Excluir tickets',
  segment_view: 'Ver segmentos',
  segment_create: 'Criar segmentos',
  segment_edit: 'Editar segmentos',
  segment_delete: 'Excluir segmentos',
  product_view: 'Ver produtos',
  product_create: 'Criar produtos',
  product_edit: 'Editar produtos',
  product_delete: 'Excluir produtos',
  report_crm_view: 'Ver relatórios CRM',
  report_conversation_view: 'Ver relatórios de conversas',
  report_agent_view: 'Ver relatórios de agentes',
  report_export: 'Exportar relatórios',
  conversation_manage: 'Gerenciar todas as conversas',
  conversation_unassigned_manage: 'Gerenciar conversas não atribuídas',
  conversation_participating_manage: 'Gerenciar apenas conversas atribuídas',
  contact_view: 'Ver contatos',
  contact_create: 'Criar contatos',
  contact_edit: 'Editar contatos',
  contact_delete: 'Excluir contatos',
  contact_export: 'Exportar contatos',
  contact_import: 'Importar contatos',
  company_view: 'Ver empresas',
  company_create: 'Criar empresas',
  company_edit: 'Editar empresas',
  company_delete: 'Excluir empresas',
  settings_manage_agents: 'Gerenciar agentes',
  settings_manage_roles: 'Gerenciar papéis',
  settings_manage_inboxes: 'Gerenciar caixas de entrada',
  settings_manage_account: 'Gerenciar configurações da conta',
  settings_manage_integrations: 'Gerenciar integrações',
  social_view: 'Ver módulo Social e comentários',
  social_manage: 'Responder comentários, ocultar, abrir DMs',
  social_configure: 'Configurar módulo Social e Brain Social',
  macro_manage: 'Criar, editar e excluir macros de qualquer agente',
  workflow_view: 'Ver workflows',
  workflow_manage: 'Criar, editar e excluir workflows',
  broadcast_view: 'Ver disparos em massa',
  broadcast_create: 'Criar disparos em massa',
  broadcast_manage: 'Editar, pausar, retomar e excluir disparos',
  captain_view: 'Ver configurações do Brain/Captain',
  captain_manage: 'Configurar assistentes e ferramentas de IA',
  agent_manage: 'Adicionar, remover e atribuir papéis a agentes',
  crm_config_manage: 'Configurar CRM (motivos de fechamento, labels, campos)',
};
